import React from 'react';

function deviceTypeFromViewport() {
    if (typeof window === 'undefined') {
        return 'desktop';
    }

    return window.matchMedia('(min-width: 64em)').matches ? 'desktop' : 'mobile';
}

function LeftNavigationItems({navigationItem, deviceType}) {
    if (!navigationItem?.slicedLeftSubNavigationItemIds?.length) {
        return null;
    }

    return navigationItem.slicedLeftSubNavigationItemIds
        .map((id) => navigationItem.subNavigationItems?.find((item) => item.id === id))
        .filter(Boolean)
        .map((item) => (
            <a
                key={item.id}
                href={item.url}
                className={`onsite-navigation__item onsite-navigation__item-link -level__${item.level} onsite-navigation__item-label`}
                jsh-landmark=""
                jsh-landmark__navi={`ln\\${item.id}\\\\${deviceType}\\`}
            >
                {item.hasNewFlag && <span className="onsite-navigation__item-link-flag">Neu</span>}
                {item.title}
            </a>
        ));
}

export default function LeftNavigation({onsiteNavigation}) {
    if (!onsiteNavigation) {
        return null;
    }

    const deviceType = deviceTypeFromViewport();

    return (
        <div className="onsite-navigation -large article-overview__left-navigation">
            <div className={`onsite-navigation__level -level__${onsiteNavigation.navigationItem.level}`}>
                <div className={`onsite-navigation__headline -level__${onsiteNavigation.navigationItem.level}`}>
                    <div className="onsite-navigation__headline-title">{onsiteNavigation.navigationItem.title}</div>
                </div>
                {onsiteNavigation.subNavigationItems.map((item) => (
                    <React.Fragment key={item.id}>
                        <a
                            href={item.url}
                            className={`onsite-navigation__item onsite-navigation__item-link -level__${item.level}${item.active ? ' -is-active' : ''}`}
                            jsh-landmark=""
                            jsh-landmark__navi={`ln\\${item.id}\\\\${deviceType}\\`}
                        >
                            {item.title}
                        </a>
                        <LeftNavigationItems navigationItem={item} deviceType={deviceType} />
                        {item.showMoreLinkInLeftNavigation && (
                            <a
                                href={item.url}
                                className="onsite-navigation__item onsite-navigation__item-link -more onsite-navigation__item-label"
                                jsh-landmark=""
                                jsh-landmark__navi={`ln\\${item.id}\\more\\${deviceType}\\`}
                            >
                                mehr ...
                            </a>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
}
